import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Key, CheckCircle } from 'lucide-react';

export function LoginIllustration() {
  return (
    <div className="relative h-full flex items-center justify-center">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 to-indigo-50/50" />
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path
                d="M 40 0 L 0 0 0 40"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                className="text-blue-100"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      {/* Floating Elements */}
      <div className="relative">
        {/* Central Shield */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          <div className="w-32 h-32 bg-blue-500/10 rounded-full flex items-center justify-center">
            <Shield className="w-16 h-16 text-blue-500" />
          </div>
        </motion.div>

        {/* Orbiting Elements */}
        {[0, 72, 144, 216, 288].map((rotation, index) => (
          <motion.div
            key={rotation}
            initial={{ rotate: rotation, scale: 0 }}
            animate={{ 
              rotate: [rotation, rotation + 360],
              scale: 1
            }}
            transition={{
              rotate: {
                duration: 20,
                repeat: Infinity,
                ease: "linear"
              },
              scale: {
                duration: 0.5,
                delay: index * 0.1
              }
            }}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            style={{ width: '200px', height: '200px' }}
          >
            <div className="absolute -top-4 left-1/2 -translate-x-1/2">
              {[Lock, Key, CheckCircle][index % 3] && (
                <div className="w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center">
                  {React.createElement([Lock, Key, CheckCircle][index % 3], {
                    className: "w-4 h-4 text-blue-500"
                  })}
                </div>
              )}
            </div>
          </motion.div>
        ))}

        {/* Floating Particles */}
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 rounded-full bg-blue-500/20"
            initial={{
              x: Math.random() * 200 - 100,
              y: Math.random() * 200 - 100,
              scale: 0
            }}
            animate={{
              x: Math.random() * 200 - 100,
              y: Math.random() * 200 - 100,
              scale: [0, 1, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              delay: i * 0.2,
            }}
          />
        ))}
      </div>
    </div>
  );
}